import { cva, type VariantProps } from 'class-variance-authority';

export const spinnerVariants = cva(
  'inline-block shrink-0 rounded-full border-2 border-current border-r-transparent motion-safe:animate-spin',
  {
    variants: {
      size: { sm: 'size-3', md: 'size-4', lg: 'size-5.5' },
    },
    defaultVariants: { size: 'md' },
  },
);

export type SpinnerVariants = VariantProps<typeof spinnerVariants>;
